import * as m from "mithril";
import { MessageProvider } from "../../context/AppMessages";
import { getBusTypeString, getIntlStringValue } from "../../helpers/StringHelpers";
import MiniTripItineraryView from "../../components/MiniTripItineraryView";
import { InternationalStringDTO, TentativeBookingDTO } from "../../apiclient/ApiDtos";
import { OrderedSeatsComponent } from "./OrderedSeatComponent";
import { PickupDropOffDetailsComponent } from "../common/pickupdropoffInfo/PickupDropOffInfoDetails";
import { SubtotalDetailsComponent } from "./SubtotalDetailsComponent";
import { SeatsAutoAssignmentInfo } from "./SeatsAutoAssignmentInfo";

function tbRow(label: string, valueContent: any, valueContentAlignment?: "left" | "right") {
  let alignmentClass = (valueContentAlignment == "right") ? "text-right" : "";
  return m("tr", [
    m("td.text-muted px-0", { style: "width:150px;word-break:break-word;" }, label),
    m("td.px-0", { "class": "text-right", style: "word-break:break-word;" }, valueContent)
  ]
  );
}

export default function TentativeBookingDetails(): m.Component<{
  messageProvider: MessageProvider,
  tentativeBooking: TentativeBookingDTO,
  showTravellerInfoUpdateAction?: boolean,
  onTravellerInfoUpdateRequested?: () => void
}> {
  return {

    view(vnode) {
      let tentativeBooking = vnode.attrs.tentativeBooking;
      let trip = vnode.attrs.tentativeBooking.trip;
      let traveller = vnode.attrs.tentativeBooking.traveller;
      let messageProvider = vnode.attrs.messageProvider;
      let currLang = messageProvider.getCurrentLang();
      let seatSelections = tentativeBooking.seatOrder.seatSelections;

      let busTypeString = getBusTypeString(trip, currLang);

      let hasPickupDropOffOrder = (tentativeBooking.pickUpOrder != null && tentativeBooking.pickUpOrder.lineItems.length > 0)
        || (tentativeBooking.dropOffOrder != null && tentativeBooking.dropOffOrder.lineItems.length > 0);

      let notices: InternationalStringDTO[] = tentativeBooking.trip.notices || [];
      return m("div",
        [
          m("div.card",
            [
              m("div.card-body", [
                m("div.font-weight-bold mt-1 mb-3",
                  messageProvider.get("section.trip_summary_title")
                ),

                m(MiniTripItineraryView, {
                  trip: vnode.attrs.tentativeBooking.trip,
                  messageProvider,
                  size: 'medium',
                  fill: true
                }),

                m("div.mt-4 small", [
                  m("div.text-muted", messageProvider.get("trip.route")),
                  m("div.mt-1", m("span", getIntlStringValue(trip.fullRouteName, currLang)))
                ]),

                m("div.mt-4 small", [
                  m("div.text-muted", messageProvider.get("operator.name")),
                  m("div.mt-1", [
                    m("span", getIntlStringValue(trip.operator.name, currLang)),
                    m("span", " | "),
                    m("span", getIntlStringValue(trip.busType, currLang)),
                  ])
                ]),


              ]),
              /* m("div.card-body.border-top",
                
              ), */
              m("div.card-body", {
                class: trip.isSeatSelectionAllowed ? "pt-0" : "border-top"
              },


                trip.isSeatSelectionAllowed ?
                  m(OrderedSeatsComponent, {
                    hideTotalTicketPrice: trip.hasPickUpService || trip.hasDropOffService,
                    messageProvider: messageProvider,
                    seatSelections: tentativeBooking.seatOrder.seatSelections
                  })

                  :
                  m(SeatsAutoAssignmentInfo, {
                    messageProvider: messageProvider,
                    seatSelections: tentativeBooking.seatOrder.seatSelections
                  }),

                (notices.length > 0) ?
                  m("div", { class: "alert alert-info mt-3 mb-0 p-2" },
                    [
                      m("small.font-weight-bold",
                        messageProvider.get("trip.operator_notices", {
                          name: getIntlStringValue(tentativeBooking.trip.operator.name, currLang)
                        })
                      ),
                      notices.map(notice => {
                        return m("div", { class: "small" }, "- " + getIntlStringValue(notice, currLang))
                      })
                    ]
                  )
                  : null,
              ),

              (
                (tentativeBooking.pickUpOrder && tentativeBooking.pickUpOrder != null && tentativeBooking.pickUpOrder.lineItems.length > 0)
                || (tentativeBooking.dropOffOrder && tentativeBooking.dropOffOrder != null && tentativeBooking.dropOffOrder.lineItems.length > 0)
              ) &&
              m("div.card-body.border-top px-3",
                m(PickupDropOffDetailsComponent, {
                  messageProvider: vnode.attrs.messageProvider,
                  totalNumberOfSeats: tentativeBooking.seatOrder.numberOfSeats,
                  trip: tentativeBooking.trip,
                  pickUpOrder: tentativeBooking.pickUpOrder,
                  dropOffOrder: tentativeBooking.dropOffOrder
                })
              ),

              hasPickupDropOffOrder &&
              m("div.card-body.border-top px-3 mt-3",
                m(SubtotalDetailsComponent, {
                  messageProvider: messageProvider,
                  pickUpOrder: tentativeBooking.pickUpOrder,
                  dropOffOrder: tentativeBooking.dropOffOrder,
                  seatOrder: tentativeBooking.seatOrder,
                  subtotal: tentativeBooking.subtotal
                })
              ),

              m("div.card-body.border-top",

                m("div.font-weight-bold mb-2",
                  m("div.d-flex justify-content-between", [
                    m("span", messageProvider.get("section.traveller_info_title")),
                    (vnode.attrs.showTravellerInfoUpdateAction) ?
                      m("a.btn btn-sm btn-outline-primary", {
                        href: "#",
                        onclick: (event) => {
                          event.preventDefault();
                          if (vnode.attrs.onTravellerInfoUpdateRequested) {
                            vnode.attrs.onTravellerInfoUpdateRequested();
                          }
                        }
                      }, messageProvider.get("review.update_traveller_info")) :
                      m("div", "")
                  ])
                ),

                m("table.table.table-borderless.table-striped1.table-sm",
                  m("tbody",
                    [
                      tbRow(messageProvider.get("traveller.name"), traveller.name),
                      tbRow(messageProvider.get("traveller.phone"), traveller.phoneNumber),
                      tbRow(messageProvider.get("traveller.email"),
                        (traveller.email) ? traveller.email :
                          m("span.text-muted", `(${messageProvider.get('traveller.no_fill')})`)
                      ),
                      //tbRow(messageProvider.get("traveller.special_request"), traveller.specialRequest),
                    ]
                  )
                ),

                m("div.font-weight-bold mt-4 mb-2",
                  messageProvider.get("traveller.special_request")
                ),
                (traveller.specialRequest) ?
                  m("div.mt-2", traveller.specialRequest) :
                  m("div.text-muted", `(${messageProvider.get('traveller.no_fill')})`)
              )
            ]
          ),
        ]
      )
    }
  }
}